export enum PlannerDriverPlanListParamsPlanType {
  EXISTING_PLAN = "EXISTING_PLAN",
  NEW_PLAN = "NEW_PLAN",
}

export enum PlannerDriverPlanListParamsSorterType {
  START_DATE_ASC = "START_DATE_ASC",
  START_DATE_DESC = "START_DATE_DESC",
  END_DATE_ASC = "END_DATE_ASC",
  END_DATE_DESC = "END_DATE_DESC",
  DISTANCE_TO_ADDRESS_ASC = "DISTANCE_TO_ADDRESS_ASC",
  DISTANCE_TO_ADDRESS_DESC = "DISTANCE_TO_ADDRESS_DESC",
  DISTANCE_TO_POINT_ASC = "DISTANCE_TO_POINT_ASC",
  DISTANCE_TO_POINT_DESC = "DISTANCE_TO_POINT_DESC",
  DRIVER_NAME_ASC = "DRIVER_NAME_ASC",
  DRIVER_NAME_DESC = "DRIVER_NAME_DESC",
}

export type PlannerDriverPlanListParamsSorter =
  | PlannerDriverPlanListParamsDriverNameAscSorter
  | PlannerDriverPlanListParamsDriverNameDescSorter
  | PlannerDriverPlanListParamsStartDateAscSorter
  | PlannerDriverPlanListParamsStartDateDescSorter
  | PlannerDriverPlanListParamsEndDateAscSorter
  | PlannerDriverPlanListParamsEndDateDescSorter
  | PlannerDriverPlanListParamsDistanceToAddressAscSorter
  | PlannerDriverPlanListParamsDistanceToAddressDescSorter
  | PlannerDriverPlanListParamsDistanceToPointAscSorter
  | PlannerDriverPlanListParamsDistanceToPointDescSorter;

export type PlannerDriverPlanListParamsDriverNameAscSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.DRIVER_NAME_ASC;
};
export type PlannerDriverPlanListParamsDriverNameDescSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.DRIVER_NAME_DESC;
};

export type PlannerDriverPlanListParamsStartDateAscSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.START_DATE_ASC;
};
export type PlannerDriverPlanListParamsStartDateDescSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.START_DATE_DESC;
};

export type PlannerDriverPlanListParamsEndDateAscSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.END_DATE_ASC;
};
export type PlannerDriverPlanListParamsEndDateDescSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.END_DATE_DESC;
};

export type PlannerDriverPlanListParamsDistanceToAddressAscSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.DISTANCE_TO_ADDRESS_ASC;
  relativeTo: string;
  dateFrom?: Date;
  dateTo?: Date;
};

export type PlannerDriverPlanListParamsDistanceToAddressDescSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.DISTANCE_TO_ADDRESS_DESC;
  relativeTo: string;
  dateFrom?: Date;
  dateTo?: Date;
};

export type PlannerDriverPlanListParamsDistanceToPointAscSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.DISTANCE_TO_POINT_ASC;
  dateFrom?: Date;
  dateTo?: Date;
  latitude: number;
  longitude: number;
};

export type PlannerDriverPlanListParamsDistanceToPointDescSorter = {
  sorterType: PlannerDriverPlanListParamsSorterType.DISTANCE_TO_POINT_DESC;
  dateFrom?: Date;
  dateTo?: Date;
  latitude: number;
  longitude: number;
};

export type PlannerDriverPlanListParamsAddress = {
  query: string;
  dateFrom?: Date;
  dateTo?: Date;
};

type PlannerDriverPlanListParams = {
  orderUuid?: string;
  taxiCorporationUuid?: string;
  page?: number;
  pageSize?: number;
  planType?: PlannerDriverPlanListParamsPlanType[];
  orderQuery?: string;
  driverName?: string;
  address?: PlannerDriverPlanListParamsAddress;
  sort?: PlannerDriverPlanListParamsSorter;
};

export default PlannerDriverPlanListParams;
